import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetScrapFinanceTradesRequestModel, GetScrapFinanceTradesResponseModel } from "@/features/accounts/scrap-finance/services/get-trades-model";

export class GetScrapFinanceTradesApi {
  /**
   * 銀行明細取得API
   */
  public getScrapFinanceTrades = async (
    param: GetScrapFinanceTradesRequestModel
  ): Promise<GetScrapFinanceTradesResponseModel[]> => {
    const path = `/api/scrapingaccounts/finances/trades`;
    const res = await ApiClient.instance.get<GetScrapFinanceTradesResponseModel[]>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
